import { useState } from 'react';

const aboutFaqs = [
  {
    question: '凪光在线观看是完全免费的吗？',
    answer: '是的，凪光在线观看完全免费。我们坚持「免费、高清、及时」的核心理念，不设置任何会员门槛或隐藏收费，所有内容均可免费在线观看。',
  },
  {
    question: '凪光系列目前有几季？',
    answer: '凪光系列目前已推出第一季（24话，已完结）、第二季「深海之章」（24话，连载中）、剧场版「永恒之约」以及OVA特典「夏日的回忆」和「冬日的约定」。第三季已正式宣布制作，预计2027年播出。',
  },
  {
    question: '如何在手机上观看凪光？',
    answer: '凪光在线观看完美支持移动端播放，您只需在手机浏览器中打开我们的网站即可直接观看，无需下载任何App。我们的播放器已针对移动端进行优化，确保触屏操作流畅便捷。',
  },
  {
    question: '凪光的中文字幕是官方翻译吗？',
    answer: '我们采用专业翻译团队精心制作的中文字幕，确保翻译准确、表达自然。所有字幕均经过多轮校对和润色，力求为观众呈现最佳的中文观影体验。',
  },
];

const testimonials = [
  {
    name: '动漫迷小陈',
    text: '凪光是我近年来最喜欢的原创动画！感谢这个网站让我能随时回顾经典剧情，画质超棒，更新也快，已经推荐给身边所有朋友了。',
    rating: 5,
  },
  {
    name: '影视评论人·林',
    text: '作为专业的动画评论人，我一直在关注凪光系列的发展。这个网站的信息整理非常全面，从剧情到声优阵容一应俱全，是做研究的好帮手。',
    rating: 5,
  },
  {
    name: '大学动漫社·王社长',
    text: '我们社团每周五都会组织大家在这里一起看凪光第二季的更新，气氛超好！网站的播放流畅度很棒，从来没有卡过。希望能一直做下去！',
    rating: 5,
  },
  {
    name: '追番达人·阿星',
    text: '从第一季开始就在这里追凪光了，网站的更新速度和日本几乎同步，翻译质量也很高，而且完全免费，真的是良心平台！',
    rating: 5,
  },
  {
    name: '二次元爱好者·小雨',
    text: '找凪光的资源找了很久，终于在这里看到了全集高清版本！角色介绍和原声音乐板块也做得很用心，已经把这个网站设成了浏览器首页。',
    rating: 5,
  },
  {
    name: '插画师·Mina',
    text: '作为一名插画师，凪光的视觉风格给了我很多创作灵感。网站的剧场版介绍和设定资料整理得特别详细，是我创作参考的宝藏库。',
    rating: 5,
  },
];

const milestones = [
  { year: '2024', event: '凪光第一季在日本首播，引发热烈反响' },
  { year: '2025', event: '凪光在线观看网站正式上线，提供全集高清免费在线播放服务' },
  { year: '2025', event: 'OVA特典「夏日的回忆」上线，网站月访问量突破50万' },
  { year: '2026', event: '第二季「深海之章」开播，网站月访问量突破200万' },
  { year: '2026', event: '剧场版「永恒之约」上映，同步上线专题页面' },
  { year: '2026', event: '第三季制作决定公布，网站全面升级体验' },
];

export default function AboutContent() {
  const [formState, setFormState] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formMessage, setFormMessage] = useState('');
  const [faqOpen, setFaqOpen] = useState<number | null>(null);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = (formData.get('phone_alt') as string || '').trim();
    if (honeypot) {
      setFormState('success');
      setFormMessage('感谢您的留言，我们会尽快回复！');
      return;
    }
    formData.delete('phone_alt');
    setFormState('loading');
    try {
      const res = await fetch('https://readdy.ai/api/form/d9u4u6n8l97n3eas3hfg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const text = await res.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string }; message?: string } | null = null;
      try { parsed = JSON.parse(text); } catch { /* ignore */ }
      if (res.ok && parsed?.code === 'OK') {
        setFormState('success');
        setFormMessage('感谢您的留言，我们会尽快回复！');
        form.reset();
      } else {
        const msg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || text || '提交失败，请稍后重试';
        setFormState('error');
        setFormMessage(msg.includes('spam') || msg.includes('form data is spam') ? '提交失败，请稍后重试' : msg);
      }
    } catch {
      setFormState('error');
      setFormMessage('网络错误，请稍后重试');
    }
  };

  return (
    <section className="bg-background-50">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6 py-10 md:py-14">
        <div className="text-center mb-12">
          <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900">
            关于凪光在线观看
          </h1>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            致力于为凪光粉丝提供最优质、最高清、最及时的在线观影体验
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 mb-14">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-5">
              <a href="#mission">我们的使命</a>
            </h2>
            <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              <p>
                凪光在线观看成立于2025年，是一个专注于凪光系列作品的综合性在线观影平台。我们深知每一位粉丝对这部作品的喜爱与期待，因此我们以最高的标准要求自己——从画质优化到更新速度，从内容整理到用户体验，每一个细节都力求做到极致。
              </p>
              <p>
                我们的团队由一群热爱日本动画的资深粉丝和专业技术开发人员组成。我们不仅提供凪光全集的免费高清在线播放服务，还精心整理了剧情介绍、角色档案、声优阵容、原声音乐等丰富内容，让每一位访客都能在这里找到关于凪光的一切。
              </p>
              <p>
                我们坚持「免费、高清、及时」的核心理念，不设置任何会员门槛或隐藏收费，让每一位凪光的粉丝都能无门槛地享受这部优秀作品带来的感动与快乐。
              </p>
            </div>

            <div className="mt-8 grid grid-cols-3 gap-4">
              <div className="text-center p-4 bg-background-100 rounded-lg">
                <p className="text-2xl md:text-3xl font-heading font-bold text-primary-500">380万+</p>
                <p className="text-xs text-foreground-500 mt-1">累计播放量</p>
              </div>
              <div className="text-center p-4 bg-background-100 rounded-lg">
                <p className="text-2xl md:text-3xl font-heading font-bold text-accent-500">99.8%</p>
                <p className="text-xs text-foreground-500 mt-1">用户好评率</p>
              </div>
              <div className="text-center p-4 bg-background-100 rounded-lg">
                <p className="text-2xl md:text-3xl font-heading font-bold text-primary-500">24h</p>
                <p className="text-xs text-foreground-500 mt-1">同步更新时间</p>
              </div>
            </div>
          </div>

          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-5">
              <a href="#history">发展历程</a>
            </h2>
            <div className="space-y-0">
              {milestones.map((m, i) => (
                <div key={i} className="flex gap-4 pb-5 relative">
                  {i < milestones.length - 1 && (
                    <div className="absolute left-[11px] top-8 bottom-0 w-px bg-background-300"></div>
                  )}
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-primary-500 flex items-center justify-center mt-0.5">
                    <div className="w-2 h-2 rounded-full bg-background-50"></div>
                  </div>
                  <div>
                    <span className="text-xs font-semibold text-primary-500">{m.year}</span>
                    <p className="text-sm text-foreground-700 mt-0.5">{m.event}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mb-14">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 text-center mb-8">
            <a href="#testimonials">用户口碑</a>
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {testimonials.map((t, i) => (
              <div key={i} className="bg-background-100 border border-background-200 rounded-lg p-5">
                <div className="flex items-center gap-1 mb-3">
                  {Array.from({ length: t.rating }).map((_, j) => (
                    <i key={j} className="ri-star-fill text-accent-500 text-sm"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  &ldquo;{t.text}&rdquo;
                </p>
                <p className="text-xs font-semibold text-foreground-900">
                  — {t.name}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div className="mb-14 max-w-3xl mx-auto">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 text-center mb-8">
            <a href="#about-faq">常见问题</a>
          </h2>
          <div className="space-y-3">
            {aboutFaqs.map((faq, index) => (
              <div
                key={index}
                className="bg-background-50 border border-background-200 rounded-lg overflow-hidden"
              >
                <button
                  onClick={() => setFaqOpen(faqOpen === index ? null : index)}
                  className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors"
                >
                  <span className="text-sm font-medium text-foreground-900 pr-4">
                    {faq.question}
                  </span>
                  <span className={`flex-shrink-0 w-6 h-6 flex items-center justify-center transition-transform duration-300 ${
                    faqOpen === index ? 'rotate-45' : ''
                  }`}>
                    <i className="ri-add-line text-foreground-500 text-lg"></i>
                  </span>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    faqOpen === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <div className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div id="contact" className="max-w-2xl mx-auto">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 text-center mb-8">
            <a href="#contact">联系我们</a>
          </h2>
          <div className="bg-background-100 border border-background-200 rounded-lg p-6 md:p-8">
            <form data-readdy-form onSubmit={handleSubmit} noValidate>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    姓名
                  </label>
                  <input
                    id="name"
                    name="name"
                    type="text"
                    required
                    className="w-full px-4 py-2.5 bg-background-50 border border-background-300 rounded-md text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                    placeholder="请输入您的姓名"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    邮箱
                  </label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    required
                    className="w-full px-4 py-2.5 bg-background-50 border border-background-300 rounded-md text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                    placeholder="请输入您的邮箱"
                  />
                </div>
              </div>
              <div className="mb-4">
                <label htmlFor="subject" className="block text-sm font-medium text-foreground-700 mb-1.5">
                  主题
                </label>
                <input
                  id="subject"
                  name="subject"
                  type="text"
                  required
                  className="w-full px-4 py-2.5 bg-background-50 border border-background-300 rounded-md text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                  placeholder="请输入留言主题"
                />
              </div>
              <div className="mb-4">
                <label htmlFor="message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                  留言内容
                </label>
                <textarea
                  id="message"
                  name="message"
                  rows={5}
                  maxLength={500}
                  required
                  className="w-full px-4 py-2.5 bg-background-50 border border-background-300 rounded-md text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors resize-none"
                  placeholder="请输入您的留言（最多500字）"
                ></textarea>
                <p className="text-xs text-foreground-400 mt-1">最多500字</p>
              </div>
              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="hp-field"
              />
              <button
                type="submit"
                disabled={formState === 'loading'}
                className="whitespace-nowrap w-full py-3 bg-primary-500 hover:bg-primary-600 disabled:bg-primary-300 text-background-50 rounded-md font-medium text-sm transition-colors cursor-pointer"
              >
                {formState === 'loading' ? '提交中...' : '发送留言'}
              </button>
              {formState === 'success' && (
                <p className="mt-3 text-sm text-green-600 text-center">{formMessage}</p>
              )}
              {formState === 'error' && (
                <p className="mt-3 text-sm text-red-600 text-center">{formMessage}</p>
              )}
            </form>
          </div>

          <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-4 text-center">
            <div className="p-4">
              <div className="w-10 h-10 mx-auto mb-2 flex items-center justify-center rounded-full bg-primary-100">
                <i className="ri-mail-line text-primary-600 text-lg"></i>
              </div>
              <p className="text-sm font-medium text-foreground-900">电子邮箱</p>
              <p className="text-xs text-foreground-500 mt-0.5">contact@nagihikari.com</p>
            </div>
            <div className="p-4">
              <div className="w-10 h-10 mx-auto mb-2 flex items-center justify-center rounded-full bg-accent-100">
                <i className="ri-global-line text-accent-600 text-lg"></i>
              </div>
              <p className="text-sm font-medium text-foreground-900">官方网站</p>
              <p className="text-xs text-foreground-500 mt-0.5">www.nagihikari.com</p>
            </div>
            <div className="p-4">
              <div className="w-10 h-10 mx-auto mb-2 flex items-center justify-center rounded-full bg-primary-100">
                <i className="ri-time-line text-primary-600 text-lg"></i>
              </div>
              <p className="text-sm font-medium text-foreground-900">更新时间</p>
              <p className="text-xs text-foreground-500 mt-0.5">每周五更新</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}